export default "__VITE_ASSET__Xo2otaR4__"